export const CONTENT_COLLECTION_ROUTE_NAME = 'content.collection';
export const CONTENT_COLLECTION_DETAIL_ROUTE_NAME = 'content.collection.detail';
